import React, { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import './style.scss';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

const LandingPage = () => {
  return (
    <Fragment>
      <Header />
      <Outlet />
      <Footer />
    </Fragment>
  );
};

export default LandingPage;
